import CourseService from "../services/course.service";

export const course = {
  namespaced: true,
  state: {
    courseId: 1,
    progressing: true,
    module: 1,
    moduleLength: 0,
    step: 1,
    progress: {},
    courseData: {},
    courseTree: {}
  },
  actions: {
    getCourseAction({ dispatch, commit, state }) {
      return CourseService.getCourse(state.courseId).then(
        response => {
          commit("setCourseData", response);
          commit("setModuleLength", response.modules.length);
          dispatch("buildTree");
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getProgressAction({ commit, rootState }) {
      return CourseService.getProgress(rootState.auth.user.id).then(
        response => {
          commit("setProgress", response[0]);
          return Promise.resolve(response[0]);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateProgressStateAction({commit}, data) {
      commit("updateProgress", data);
    },
    setModuleCompleteInStateAction({commit}, data) {
      commit("setModuleComplete", data);
    },
    async updateProgressAction({ state }) {
      return CourseService.updateProgress(state.progress);
    },
    createProgressAction({ state, commit, rootState }) {
      let progress = {
        user: rootState.auth.user,
        course: state.courseId,
        progress: state.courseTree
      };
      console.log(state.courseTree);
      return CourseService.createProgress(progress).then(
        response => {
          commit("setProgress", response);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    buildTree({ commit, state }) {
      let course = {
        modules: []
      };
      for (let i = 0; i < state.courseData.modules.length; i++) {
        course.modules[i] = state.courseData.modules[i];
        course.modules[i].complete = false;
        course.modules[i].steps = [];
        for (let x = 0; x < state.courseData.steps.length; x++) {
          if (
            state.courseData.steps[x].module ==
            state.courseData.modules[i].number
          ) {
            let step = state.courseData.steps[x];
            step.complete = false;
            step.data == {};
            course.modules[i].steps.push(step);
          }
        }
      }
      //console.log("couseTree:", course);
      commit("setCourseTree", course);
    }
  },
  getters: {
    courseData: state => state.courseData,
    progress: state => state.progress,
    moduleLength: state => state.moduleLength,
    step: state => state.step,
    module: state => state.module,
  },
  mutations: {
    setProgress(state, data) {
      //console.log("setProgress", data);
      state.progress = data;
    },
    setModuleComplete(state, data) {
      state.progress.progress.modules[data.module - 1].complete = true;
    },
    updateProgress(state, data) {
      state.progress.progress.modules[data.module - 1].steps[
        data.step - 1
      ].complete = true;
      state.progress.progress.modules[data.module - 1].steps[
        data.step - 1
      ].data = data.data;
    },
    setCourseData(state, data) {
      state.courseData = data;
    },
    setCourseTree(state, data) {
      state.courseTree = data;
    },
    setCurrentStep(state, data) {
      state.module = data.module;
      state.step = data.step;
    },
    setModuleLength(state, data) {
      state.moduleLength = data;
    }
  }
};
